/* eslint-disable react/no-unknown-property */
import React from 'react';
import { Button as AntButton } from 'antd';
import PropTypes from 'prop-types';

const Button = ({
  type,
  htmlType,
  size,
  className,
  block,
  text,
  icon,
  shape,
  onClick,
  disabled,
  style,
  danger,
  loading,
  ...rest
}) => (
  <AntButton
    type={type}
    htmlType={htmlType}
    size={size}
    shape={shape}
    block={block}
    icon={icon}
    className={className}
    disabled={disabled}
    onClick={onClick}
    danger={danger}
    style={style}
    loading={loading}
    {...rest}>
    {text}
  </AntButton>
);

Button.defaultProps = {
  type: '',
  htmlType: '',
  size: '',
  className: '',
  block: false,
  icon: '',
  shape: '',
  disabled: false,
  onClick: () => {},
  style: {},
  danger: false,
};

Button.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  type: PropTypes.string,
  htmlType: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  block: PropTypes.bool,
  danger: PropTypes.bool,
  shape: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  style: PropTypes.instanceOf(Object),
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
};

export default Button;
